import { useRouter } from 'hooks/useRouter'

const monitoringRoutes = [
  '/reports/monitoring/fluids',
  '/reports/monitoring/meals',
  '/reports/monitoring/turns',
  '/reports/monitoring/weight',
  '/reports/monitoring/activity',
  '/reports/monitoring/mood',
  '/reports/monitoring/temperature',
  '/reports/monitoring/wash',
  '/reports/monitoring/custom'
]

const carePlanReportRoutes = [
  '/reports/care-planning/care-plans',
  '/reports/care-planning/risk-assessments'
]

const emarRoutes = [
  '/reports/emar/medication-rounds',
  '/reports/emar/stock-discrepancies',
  '/reports/emar/stock-levels'
]

const incidentRoutes = ['/reports/incidents/list', '/reports/incidents']

const rosteringReportRoutes = [
  '/reports/rostering/rota-overview',
  '/reports/rostering/pay-report'
]

export const useReportsSidebarNavigation = () => {
  const router = useRouter()

  const { location } = router

  const cleanRoute = location.pathname

  const getLastUrlKey = () =>
    router.location.pathname.split('/reports/').slice(-1)[0]

  const getDefaultOpenKey = () => {
    if (monitoringRoutes.includes(cleanRoute)) {
      return 'monitoring-route'
    }

    if (carePlanReportRoutes.includes(cleanRoute)) {
      return 'care-planning-route'
    }

    if (emarRoutes.includes(cleanRoute)) {
      return 'emar-route'
    }

    if (incidentRoutes.includes(cleanRoute)) {
      return 'incidents-route'
    }

    if (rosteringReportRoutes.includes(cleanRoute)) {
      return 'rostering'
    }

    return ''
  }

  const defaultOpenKey = getDefaultOpenKey()

  const lastUrlKey = getLastUrlKey()

  const getSelectedKey = () => {
    switch (defaultOpenKey) {
      case 'monitoring-route':
      case 'care-planning-route':
      case 'emar-route':
      case 'incidents-route':
        return lastUrlKey
      // Keep this for future exceptions in routes as inside residents navigation
      default:
        return lastUrlKey
    }
  }

  const defaultSelectedKey = getSelectedKey()

  const exceptionWidthRoutes = ['meals', 'fluids', 'risk-assessments'].includes(
    lastUrlKey
  )

  return { defaultOpenKey, defaultSelectedKey, exceptionWidthRoutes }
}
